import * as React from "react";
import type { SVGProps } from "react";

const SvgOptical = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={35}
    height={13}
    viewBox="0 0 35 13"
    {...props}
  >
    <defs>
      <path id="optical_svg__a" d="M0 .001h35V13H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="optical_svg__b" fill="#fff">
        <use xlinkHref="#optical_svg__a" />
      </mask>
      <path
        fill="#182744"
        d="M14.5 6.5c0 .258-.038.503-.076.75C14.059 9.65 12 11.5 9.5 11.5S4.94 9.65 4.576 7.25c-.037-.247-.076-.492-.076-.75 0-.256.039-.503.076-.75C4.94 3.35 7 1.5 9.5 1.5s4.559 1.85 4.924 4.25c.038.247.076.494.076.75m16 0c0 .258-.038.503-.076.75C30.059 9.65 28 11.5 25.5 11.5s-4.56-1.85-4.924-4.25c-.037-.247-.076-.492-.076-.75 0-.256.039-.503.076-.75C20.94 3.35 23 1.5 25.5 1.5s4.559 1.85 4.924 4.25c.038.247.076.494.076.75m3.75-.75h-2.296a6.498 6.498 0 0 0-12.907 0h-3.093a6.498 6.498 0 0 0-12.907 0H.75a.75.75 0 0 0 0 1.5h2.297A6.5 6.5 0 0 0 9.5 13a6.5 6.5 0 0 0 6.454-5.75h3.093A6.5 6.5 0 0 0 25.5 13a6.5 6.5 0 0 0 6.454-5.75h2.296a.75.75 0 1 0 0-1.5"
        mask="url(#optical_svg__b)"
      />
      <path
        fill="#182744"
        d="M9.5 2.25a.75.75 0 0 0 0 1.5c1.255 0 2.304.85 2.633 2 .069.24.117.489.117.75a.75.75 0 1 0 1.5 0c0-.256-.032-.505-.076-.75A4.25 4.25 0 0 0 9.5 2.25m16 0a.75.75 0 0 0 0 1.5c1.255 0 2.304.85 2.633 2 .069.24.117.489.117.75a.75.75 0 1 0 1.5 0c0-.256-.032-.505-.076-.75a4.25 4.25 0 0 0-4.174-3.5"
      />
    </g>
  </svg>
);
export default SvgOptical;
